import React, { useState, useEffect } from 'react';
import {
  Loading,
  Pecten,
  Sizes,
} from '@sede-enterprise/shell-ds-react-framework';
import {
  AuthorizationServiceConfiguration,
  RedirectRequestHandler,
  FetchRequestor,
  AuthorizationRequest,
} from '@openid/appauth';
import { LoginWrapper } from './style';
import { getEnv } from 'src/utils/env.vite';

function Login() {
  const [message, setMessage] = useState('Logging in...');
  const [isLoading, setIsLoading] = useState<boolean>(true);
  useEffect(() => {
    const authorizationHandler = new RedirectRequestHandler();
    AuthorizationServiceConfiguration.fetchFromIssuer(
      getEnv('VITE_APP_TOKEN_PING_URL') ?? '',
      new FetchRequestor()
    )
      .then((response) => {
        sessionStorage.setItem('token_endPoint', JSON.stringify(response));
        const authRequest = new AuthorizationRequest({
          client_id: getEnv('VITE_APP_PING_CLIENT_ID') ?? '',
          redirect_uri: getEnv('VITE_APP_REDIRECT_URL') ?? '',
          scope: 'openid email profile',
          response_type: AuthorizationRequest.RESPONSE_TYPE_CODE,
          state: undefined,
        });
        authorizationHandler.performAuthorizationRequest(response, authRequest);
      })
      .catch((error) => {
        setMessage(error.message);
        setIsLoading(false);
      });
  }, []);

  return (
    <LoginWrapper>
      <Pecten size={Sizes.Large} />
      <h1 className='title'>Genesis</h1>
      {isLoading && <Loading size='medium' className='loader' />}
      <div className='login-message'>{message}</div>
    </LoginWrapper>
  );
}
export default Login;
